import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

export default function ThankYou() {
  const location = useLocation();
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-2xl mx-auto text-center py-16"
    >
      <h1 className="text-4xl font-bold text-gray-800 mb-6">
        Terima Kasih!
      </h1>
      <p className="text-xl text-gray-600 mb-8">
        Pesanan anda telah berjaya dihantar. Kami akan menghubungi anda dalam masa terdekat.
      </p>
      <div className="animate-bounce text-6xl mb-8">
        🎉
      </div>
      <p className="text-gray-500">
        Reference ID: {location.pathname.split('/').pop()}
      </p>
    </motion.div>
  );
}